var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "container",
      staticStyle: { height: "100%" },
      on: { click: _vm.allIfreamHide },
    },
    [
      _c(
        "div",
        { staticClass: "breadcrumb" },
        [
          _c(
            "el-breadcrumb",
            { attrs: { separator: "" } },
            [
              _c("el-breadcrumb-item", [
                _c("div", { staticClass: "div1" }, [_vm._v("商品管理")]),
              ]),
              _c("el-breadcrumb-item", [
                _c("div", { staticClass: "div2" }, [_vm._v("品牌管理")]),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "content" },
        [
          _c("h2", [_vm._v("品牌管理")]),
          _c("h3", [_vm._v("数据筛选")]),
          _c(
            "el-form",
            {
              ref: "form",
              attrs: {
                inline: true,
                model: _vm.queryForm,
                "label-width": "",
                size: "mini",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "品牌名称", prop: "name" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入品牌名称", maxlength: 30 },
                    model: {
                      value: _vm.queryForm.name,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.queryForm,
                          "name",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "queryForm.name",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "英文名", prop: "fenName" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入英文名", maxlength: 30 },
                    nativeOn: {
                      keyup: function ($event) {
                        _vm.queryForm.endangerName =
                          _vm.queryForm.endangerName.replace(/[^a-zA-Z]/g, "")
                      },
                    },
                    model: {
                      value: _vm.queryForm.endangerName,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.queryForm,
                          "endangerName",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "queryForm.endangerName",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "关联商户号" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        placeholder: "选择关联商户号",
                        filterable: "",
                        clearable: "",
                        "default-first-option": "",
                      },
                      on: { change: _vm.handleSelect },
                      model: {
                        value: _vm.queryForm.defWechatMchId,
                        callback: function ($$v) {
                          _vm.$set(_vm.queryForm, "defWechatMchId", $$v)
                        },
                        expression: "queryForm.defWechatMchId",
                      },
                    },
                    _vm._l(_vm.brandList, function (item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { value: item.value, label: item.label },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "所属类目：" } },
                [
                  _c("el-cascader", {
                    attrs: {
                      clearable: "",
                      options: _vm.options,
                      props: {
                        label: "categoryName",
                        value: "id",
                        checkStrictly: true,
                      },
                    },
                    on: { change: _vm.handleChangeSearch },
                    model: {
                      value: _vm.queryForm.id,
                      callback: function ($$v) {
                        _vm.$set(_vm.queryForm, "id", $$v)
                      },
                      expression: "queryForm.id",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { size: "mini", type: "primary" },
                      on: {
                        click: _vm.searchEvent,
                        keyup: function ($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          )
                            return null
                          return _vm.searchEvent.apply(null, arguments)
                        },
                      },
                    },
                    [_vm._v("搜索")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { size: "mini", plain: "" },
                      on: { click: _vm.reset },
                    },
                    [_vm._v("重置")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("div", { staticClass: "manage" }, [
        _c(
          "div",
          {
            staticStyle: {
              display: "flex",
              "justify-content": "space-between",
            },
          },
          [
            _c("p", { staticClass: "header" }, [_vm._v("管理品牌")]),
            _vm.parArray.indexOf("addTrademark") != -1
              ? _c(
                  "el-button",
                  {
                    staticStyle: { width: "120px", height: "36px" },
                    attrs: { type: "primary", size: "mini" },
                    on: {
                      click: function ($event) {
                        return _vm.addCommercial(1)
                      },
                    },
                  },
                  [_vm._v("新增品牌")]
                )
              : _vm._e(),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "table", on: { click: _vm.allIfreamHide } },
          [
            _c(
              "el-table",
              {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.loading,
                    expression: "loading",
                  },
                ],
                attrs: {
                  "header-cell-style": { background: "#f8f8f8" },
                  data: _vm.dataList,
                },
              },
              [
                _c("el-table-column", {
                  attrs: { label: "品牌名称", "min-width": "120px" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (props) {
                        return [
                          _c("div", { staticStyle: { cursor: "pointer" } }, [
                            _c("span", [_vm._v(" " + _vm._s(props.row.name))]),
                          ]),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: { label: "品牌英文名", "min-width": "120" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (props) {
                        return [
                          _c("p", { staticStyle: { cursor: "pointer" } }, [
                            _vm._v(" " + _vm._s(props.row.endangerName) + " "),
                          ]),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: { label: "关联商户号", "min-width": "120" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (props) {
                        return [
                          _vm._v(
                            " " + _vm._s(props.row.defWechatMchName) + " "
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: { label: "所属类目", "min-width": "120" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (props) {
                        return [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.getTextByJs(props.row.commodityCategoryList)
                              ) +
                              " "
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: { label: "更新时间", "min-width": "120" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (props) {
                        return [
                          _c("p", [
                            _vm._v(_vm._s(_vm.$moment(props.row.updatedTime))),
                          ]),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: { label: "操作", fixed: "right", "min-width": "100" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (props) {
                        return [
                          _vm.parArray.indexOf("trademarkEdit") != -1
                            ? _c(
                                "el-button",
                                {
                                  attrs: { type: "text" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.handleClick(props.row, 2)
                                    },
                                  },
                                },
                                [_vm._v("编辑")]
                              )
                            : _vm._e(),
                          _vm.parArray.indexOf("relevanceCommercial") != -1
                            ? _c(
                                "el-button",
                                {
                                  attrs: { type: "text" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.relevance(props.row, 1)
                                    },
                                  },
                                },
                                [_vm._v("关联商户号")]
                              )
                            : _vm._e(),
                        ]
                      },
                    },
                  ]),
                }),
              ],
              1
            ),
            _c("div", { staticClass: "page" }, [
              _c(
                "div",
                { staticClass: "block" },
                [
                  _c("el-pagination", {
                    attrs: {
                      "current-page": _vm.currentPage1,
                      "page-sizes": [10, 20, 50, 100],
                      "page-size": _vm.pageSize,
                      layout: "total, sizes, prev, pager, next, jumper",
                      total: _vm.totalNum,
                      "prev-text": "上一页",
                      "next-text": "下一页",
                    },
                    on: {
                      "size-change": _vm.handleSizeChange,
                      "current-change": _vm.handleCurrentChange,
                    },
                  }),
                ],
                1
              ),
            ]),
          ],
          1
        ),
        _c("div", { staticStyle: { height: "40px" } }),
      ]),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.amendtitle,
            "append-to-body": true,
            visible: _vm.dialogVisible,
            width: "600px",
            "before-close": _vm.handleClose,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "classifyRuleForm",
              staticClass: "demo-ruleForm",
              attrs: {
                model: _vm.ruleForm,
                "status-icon": "",
                "label-width": "100px",
                rules: _vm.rules,
              },
            },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "品牌名称",
                    prop: "name",
                    "label-width": "90px",
                  },
                },
                [
                  _c("el-input", {
                    attrs: {
                      type: "text",
                      placeholder: "请输入产品品牌名称",
                      autocomplete: "off",
                    },
                    model: {
                      value: _vm.ruleForm.name,
                      callback: function ($$v) {
                        _vm.$set(_vm.ruleForm, "name", $$v)
                      },
                      expression: "ruleForm.name",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "英文名",
                    prop: "endangerName",
                    "label-width": "90px",
                  },
                },
                [
                  _c("el-input", {
                    attrs: {
                      type: "text",
                      placeholder: "请输入英文名",
                      autocomplete: "off",
                    },
                    nativeOn: {
                      keyup: function ($event) {
                        _vm.ruleForm.endangerName =
                          _vm.ruleForm.endangerName.replace(/[^a-zA-Z]/g, "")
                      },
                    },
                    model: {
                      value: _vm.ruleForm.endangerName,
                      callback: function ($$v) {
                        _vm.$set(_vm.ruleForm, "endangerName", $$v)
                      },
                      expression: "ruleForm.endangerName",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "关联商户号", "label-width": "90px" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        placeholder: "选择关联商户号",
                        filterable: "",
                        clearable: "",
                        "default-first-option": "",
                      },
                      model: {
                        value: _vm.ruleForm.wxconfigId,
                        callback: function ($$v) {
                          _vm.$set(_vm.ruleForm, "wxconfigId", $$v)
                        },
                        expression: "ruleForm.wxconfigId",
                      },
                    },
                    _vm._l(_vm.brandList, function (item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { value: item.value, label: item.label },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "所属类目",
                    prop: "brandCategoryList",
                    "label-width": "90px",
                  },
                },
                [
                  _c("el-cascader", {
                    attrs: {
                      options: _vm.options,
                      props: {
                        label: "categoryName",
                        value: "id",
                        multiple: true,
                      },
                      "collapse-tags": "",
                      clearable: "",
                    },
                    on: { change: _vm.handleChange },
                    model: {
                      value: _vm.ruleForm.brandCategoryList,
                      callback: function ($$v) {
                        _vm.$set(_vm.ruleForm, "brandCategoryList", $$v)
                      },
                      expression: "ruleForm.brandCategoryList",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "是否上架",
                    prop: "status",
                    "label-width": "90px",
                  },
                },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.ruleForm.status,
                        callback: function ($$v) {
                          _vm.$set(_vm.ruleForm, "status", $$v)
                        },
                        expression: "ruleForm.status",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: "A" } }, [
                        _vm._v("上架"),
                      ]),
                      _c("el-radio", { attrs: { label: "S" } }, [
                        _vm._v("下架"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "btnBox" },
                [
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function ($event) {
                          _vm.dialogVisible = false
                        },
                      },
                    },
                    [_vm._v("取消")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.submitForm("classifyRuleForm")
                        },
                      },
                    },
                    [_vm._v("确定")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.titleCommercial,
            visible: _vm.dialogVisibleInput,
            width: "500px",
            "before-close": _vm.handleCloseInput,
            "append-to-body": true,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisibleInput = $event
            },
          },
        },
        [
          _c(
            "el-form",
            { ref: "form", attrs: { "label-width": "100px" } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "关联商户号" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        placeholder: "关联商户号",
                        filterable: "",
                        clearable: "",
                        "default-first-option": "",
                      },
                      model: {
                        value: _vm.defWechatMchId,
                        callback: function ($$v) {
                          _vm.defWechatMchId = $$v
                        },
                        expression: "defWechatMchId",
                      },
                    },
                    _vm._l(_vm.brandList, function (item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { value: item.value, label: item.label },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "Commercial" },
                [
                  _c("el-button", { on: { click: _vm.handleCloseInput } }, [
                    _vm._v("取 消"),
                  ]),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.handleCloseConfirm },
                    },
                    [_vm._v("确 定")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "下架",
            "append-to-body": true,
            visible: _vm.dialogVisibleForbidden,
            width: "25%",
            "before-close": _vm.handleCloseForbidden,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisibleForbidden = $event
            },
          },
        },
        [
          _c("div", { staticClass: "dialogText" }, [
            _c("h3", { staticStyle: { "font-zise": "18" } }, [
              _vm._v("是否确定下架品牌"),
            ]),
            _c("p", { staticStyle: { color: "#999999" } }, [
              _vm._v(" 是否确定下架品牌，下架后该品牌"),
              _c("span", { staticStyle: { color: "#f15043" } }, [
                _vm._v("所有支付方式及商品"),
              ]),
              _vm._v("将同时下架 "),
            ]),
          ]),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.handleCloseForbidden } }, [
                _vm._v("取 消"),
              ]),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.forbiddenBtn } },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }